import SafeMarkdown from './SafeMarkdown';

export default SafeMarkdown;
